import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';

import { $t } from 'src/tools';
import HistoryModal from './record';
import ResultModal from './result';

class Home extends Component {
  render() {
    const { visible, locales, temp, record, recordVisible } = this.props;

    return (
      <>
        <HistoryModal
          modalProps={{
            visible,
            width: '85%',
            maskClosable: false,
            bodyStyle: { paddingBottom: 0 },
            title: $t(Number(temp) === 1 ? 'import_history' : 'export_history', locales),
            footer: <Button onClick={this.handleClose}>{$t('close', locales)}</Button>,
          }}
          locales={locales}
          onClose={this.handleClose}
        />
        <ResultModal
          modalProps={{
            width: 720,
            footer: null,
            maskClosable: false,
            visible: recordVisible,
            bodyStyle: { paddingBottom: 0 },
            title: $t('operate_record', locales),
          }}
          record={record}
          locales={locales}
          onClose={this.handleRecordClose}
        />
      </>
    );
  }

  handleClose = () => {
    this.props.dispatch({ type: 'down/setState', payload: { visible: false } });
  };
  handleRecordClose = () => {
    this.props.dispatch({
      type: 'down/setState',
      payload: { recordVisible: false },
    });
  };
}

export default connect(({ downState }) => ({ ...downState }))(Home);
